// extracted by mini-css-extract-plugin
module.exports = {"page":"list_page_rCkPg","listout":"list_listout_2VdN_","listtag":"list_listtag_2DpMN","listbtn":"list_listbtn_2cWZR","img":"list_img_3fkNE"};